<template>
  <div>
    <h4 class="title font-weight-bold mb-3 orange--text text--lighten-2">
      <span v-if="userNotes.length > 0">User Notes</span>
      <span v-else>No User Notes</span>
      <v-btn
        outline
        small
        @click="showAddNoteDialog()"
      >
        Add
      </v-btn>
    </h4>
    <v-container fluid grid-list-lg class="pa-0">
      <v-layout row wrap>
        <v-flex xs12 v-for="note in userNotes" :key="note.userNoteId">
          <div class="orange lighten-4 black--text pa-3 pb-5">
            <div class="caption">
              <span class="font-weight-bold">{{ note.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
              <span v-if="note.updatedByAdminName" class="ml-2 mr-2">updated by {{ note.updatedByAdminName }} on {{ note.updatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
              <span v-else class="ml-2 mr-2">by {{ note.createdByAdminName }}</span>
              <v-btn
                icon
                small
                color="orange"
                class="ml-1 mr-1"
                @click="showEditNoteDialog(note.userNoteId)"
              >
                <v-icon small color="white">create</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                color="orange"
                class="ml-1 mr-1"
                @click="showDeleteNoteDialog(note.userNoteId)"
              >
                <v-icon small color="white">delete</v-icon>
              </v-btn>
            </div>
            <div class="subheading" v-html="note.note"></div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogAddNote" max-width="700px">
      <v-card>
        <v-card-title>
          <strong>Add User Note</strong>
        </v-card-title>
        <v-card-text>
          <v-form ref="frmAddNote" v-model="frmAddNoteValid">
            <v-textarea
              outline
              v-model="txtAddNote"
              label="Notes"
              :rules="[v => !!v || 'Notes is required']"
              :height="300"
              required
            ></v-textarea>
            <v-btn
              block
              :disabled="!frmAddNoteValid"
              @click="addNote(txtAddNote)"
            >
              Add
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditNote" max-width="700px">
      <v-card>
        <v-card-title>
          <strong>Edit User Note</strong>
        </v-card-title>
        <v-card-text>
          <v-form ref="frmEditNote" v-model="frmEditNoteValid">
            <v-textarea
              outline
              v-model="txtEditNote"
              label="Notes"
              :rules="[v => !!v || 'Notes is required']"
              :height="300"
              required
            ></v-textarea>
            <v-btn
              block
              :disabled="!frmEditNoteValid"
              @click="editNote(selectedNoteId, txtEditNote)"
            >
              Save
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDeleteNote"
      max-width="300"
    >
      <v-card>
        <v-card-title class="subheading font-weight-bold">Are you sure to delete this note?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            flat="flat"
            @click="dialogDeleteNote = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            flat="flat"
            @click="deleteNote(selectedNoteId)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="220"
    >
      <loading></loading>
    </v-dialog>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  components: {
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      loading: false,
      userNotes: [],
      dialogAddNote: false,
      frmAddNoteValid: false,
      txtAddNote: '',
      dialogEditNote: false,
      selectedNoteId: '',
      frmEditNoteValid: false,
      txtEditNote: '',
      dialogDeleteNote: false
    }
  },

  watch: {
    value (newValue, oldValue) {
      this.userNotes = newValue
    }
  },

  mounted () {
  },

  methods: {
    showAddNoteDialog: function () {
      this.txtAddNote = ''
      this.dialogAddNote = true
    },
    showEditNoteDialog: function (userNoteId) {
      // load note for editing
      this.txtEditNote = ''
      for (var i in this.userNotes) {
        if (this.userNotes[i].userNoteId === userNoteId) {
          this.txtEditNote = this.br2nl(this.userNotes[i].note)
          break
        }
      }

      this.selectedNoteId = userNoteId
      this.dialogEditNote = true
    },
    showDeleteNoteDialog: function (userNoteId) {
      this.selectedNoteId = userNoteId
      this.dialogDeleteNote = true
    },
    addNote: function (note) {
      if (this.$refs.frmAddNote.validate()) {
        var _this = this
        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/user/note', { userId: _this.userId, note: note }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogAddNote = false
              _this.refreshNotes()
            } else {
              window.alert('Unable to add note: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(this)
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
            }
          })
      }
    },
    editNote: function (userNoteId, note) {
      if (this.$refs.frmEditNote.validate()) {
        var _this = this
        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/user/note/' + userNoteId, { note: note }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogEditNote = false
              _this.refreshNotes()
            } else {
              window.alert('Unable to edit note: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(this)
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
            }
          })
      }
    },
    deleteNote: function (userNoteId) {
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/user/note/' + userNoteId)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.dialogDeleteNote = false
            _this.refreshNotes()
          } else {
            window.alert('Unable to delete note: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    },
    refreshNotes: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + _this.userId + '/notes')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.userNotes = resp.data.data

            // update v-model
            _this.$emit('input', resp.data.data)
          } else {
            console.log('unable to load user notes: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    }
  }
}
</script>
